import { FC, useEffect, useState } from 'react';
import {
  Button,
  ButtonIconPosition,
  ButtonStyles,
  ButtonSize,
  Theme,
  FAIcon,
  IconStyle,
} from '@nextgen-web-framework/all';
import { ProductButtonPropTypes } from './types/propsTypes';
import styles from './ProductButton.module.scss';
import { ProductButtonType } from './types/enums';

enum Operation {
  ADD = 'add',
  MINUS = 'minus',
}
export const ProductButton: FC<ProductButtonPropTypes> = (props) => {
  const {
    onQuantityIncrease,
    onQuantityDecrease,
    className = '',
    productCount = 0,
    maxCount = 10,
    disabled = false,
    productButtonType,
  } = props;

  const [count, setCount] = useState(productCount);

  useEffect(() => {
    setCount(productCount);
  }, [productCount]);

  const handleClick = (op: Operation): void => {
    const value = op === Operation.ADD ? Number(count) + 1 : Number(count) - 1;

    if (value >= 0 && value <= maxCount && !disabled) {
      setCount(value);
      if (op === Operation.ADD && onQuantityIncrease && typeof onQuantityIncrease === 'function') {
        onQuantityIncrease(value);
      } else if (op === Operation.MINUS && onQuantityDecrease && typeof onQuantityDecrease === 'function') {
        onQuantityDecrease(value);
      }
    }
  };

  const getProductButtonType = () => {
    switch (productButtonType) {
      case ProductButtonType.QTY_STEPPER:
        return 'cpw-product-button-qty-stepper-view';
      case ProductButtonType.PROMOTION_CARD:
        return 'cpw-product-button-promotion-card-view';
      default:
        return 'cpw-product-button';
    }
  };

  return (
    <>
      <div
        className={`${styles[getProductButtonType()]} ${className}  ${
          disabled && styles['cpw-product-button-disabled']
        }`}
      >
        <span
          id={styles['add-to-cart-reducer']}
          data-testid={'add-to-cart-reducer'}
          tabIndex={0}
          className={`${styles['icon-holder']} ${styles['icon-minus-position']} `}
          onClick={() => handleClick(Operation.MINUS)}
          onKeyDown={() => handleClick(Operation.MINUS)}
          aria-valuenow={count}
          role="spinbutton"
          aria-label="decrease-quantity"
        >
          {disabled || count === 0 ? (
            <FAIcon theme={Theme.GRAY} iconName={'minus'} iconStyle={IconStyle.REGULAR} />
          ) : (
            <FAIcon iconName={'minus'} iconStyle={IconStyle.REGULAR} />
          )}
        </span>

        <Button
          id={styles['add-to-cart-button']}
          onClick={() => {
            void 0;
          }}
          title={String(count)}
          buttonStyle={ButtonStyles.OUTLINE}
          theme={Theme.BLACK}
          iconPosition={ButtonIconPosition.RIGHT}
          size={ButtonSize.SMALL}
          tabIndex={!count ? 0 : -1}
          disabled={disabled}
        />

        <span
          id={styles['add-to-cart-incrementor']}
          data-testid={'add-to-cart-incrementor'}
          tabIndex={0}
          className={`${styles['icon-holder']} ${styles['icon-plus-position']}`}
          onClick={() => handleClick(Operation.ADD)}
          onKeyDown={() => handleClick(Operation.ADD)}
          aria-valuenow={count}
          role="spinbutton"
          aria-label="increase-quantity"
        >
          {disabled || count === maxCount ? (
            <FAIcon theme={Theme.GRAY} iconName={'plus'} iconStyle={IconStyle.REGULAR} />
          ) : (
            <FAIcon iconName={'plus'} iconStyle={IconStyle.REGULAR} />
          )}
        </span>
      </div>
    </>
  );
};

export type { ProductButtonPropTypes };
export { ProductButtonType };
